<template>
  <h1 class="page-title">Licenças</h1>

  <div class="action-panel">
    <button title="Exportar Excel" @click="downloadExcel()" class="action-text">
      <span>Exportar Excel</span>
      <img alt="Exportar tabela Excel" src="../../assets/svg/download.svg" />
    </button>

    <button
      title="Criar licença"
      @click="openLicenseModal(operations.Create)"
      class="action-text"
    >
      <span>Criar licença</span>
      <img alt="Criar licença" src="../../assets/svg/create.svg" />
    </button>
  </div>

  <Table
    :columns="columns"
    :rows="rows"
    :pagination="pagination"
    @update="updateSearch"
    :multiple-filters="true"
    :loading="loading"
  >
    <template #item-row="props">
      <!-- Verifica se o dado é da coluna "Ações" e personaliza -->
      <template v-if="props.item.field === 'action'">
        <div class="buttons">
          <button
            title="Editar licença"
            @click="openLicenseModal(operations.Update, props.item)"
            class="action"
          >
            <img alt="Editar licença" src="../../assets/svg/edit.svg" />
          </button>

          <button
            title="Visualizar documento"
            @click="getDocumentByLicenseId(props.item.row.id)"
            class="action"
            :disabled="!props.item.row.document"
          >
            <img
              alt="Visualizar documento"
              src="../../assets/svg/document.svg"
            />
          </button>
        </div>
      </template>
    </template>
  </Table>

  <CreateLicenseModal ref="CreateLicenseModalRef" />

  <MessageModal
    :id="pdfModal.id"
    :button="pdfModal.button"
    :functionModal="pdfModal.functionModal"
    :text="pdfModal.text"
    :textButton="pdfModal.textButton"
    :title="pdfModal.title"
  >
    <template #content>
      <div id="contentPDF">
        <a @click="openNewTabPDF(pdfModal.blobURL)"> Abrir em nova aba </a>
        <object :data="pdfModal.blobURL">no support</object>
      </div>
    </template>
  </MessageModal>
</template>

<script>
import { LicenseTable } from "../../services";
import { Modal } from "bootstrap";
import CreateLicenseModal from "./CreateLicenseModal.vue";
import MessageModal from "../MessageModal.vue";
import Table from "../DefaultTable/Table.vue";
import TableManagement from "../../components/DefaultTable/TableManagement";

export default {
  name: "License",

  components: {
    Table,
    MessageModal,
    CreateLicenseModal,
  },

  data() {
    return {
      // Service usado para obtenção dos dados
      service: LicenseTable,

      /* Variáveis padrões da tabela */
      // Dados
      columns: [],
      rows: [],

      // Filtros
      search: {
        columns: [],
        order_by: "user",
        order_direction: "0",
        page: "1",
        pagesize: 5,
        where: {},
      },

      // Paginação
      pagination: {
        currentPage: 1,
        lastPage: 1,
        itemsPerPage: 5,
        count: null,
      },
      /* Variáveis padrões da tabela */

      // Enum para as operações
      operations: {
        Create: "Create",
        Update: "Update",
      },

      // Objeto com as propriedades do modal que mostra o PDF
      pdfModal: {
        id: "pdfModal",
        title: "Documento",
        button: true,
        textButton: "Fechar",
        object: null,
        blobURL: null,
      },

      loading: false,
    };
  },

  async created() {
    TableManagement.new();

    // Adicionando nova coluna "Ações"
    TableManagement.addColumn({
      label: "Ações",
      field: "action",
      onDisplay: true,
      filterOptions: {
        enabled: false,
      },
    });

    // Personalizando a label da coluna "Duração"
    TableManagement.customizeColumn("duration", { label: "Duração (dias)" });
    // Personalizando largura da coluna "Nome"
    TableManagement.customizeColumn("user", { textwrap: "nowrap" });
    // Personalizando largura da coluna "Adicionado por"
    TableManagement.customizeColumn("added_by", { textwrap: "nowrap" });
    // Personalizando largura da coluna "CID"
    TableManagement.customizeColumn("cid", {
      textwrap: "nowrap",
      truncate: true,
      truncateLimit: 45,
    });
    // Personalizando o limite de caracteres da coluna "Observações"
    TableManagement.customizeColumn("description", {
      textwrap: "nowrap",
      truncate: true,
      truncateLimit: 45,
    });

    // Configuração das colunas.
    const { columns, columnsKey } = await TableManagement.getColumns(
      this.service
    );
    this.columns = columns;
    this.search.columns = columnsKey;

    // Obtém os dados iniciais da pesquisa.
    await this.updateData();
  },

  mounted() {
    this.createLicenseModal = new Modal(
      document.getElementById("createLicenseModal")
    );
  },

  methods: {
    /**
     * Atualiza as informações do objeto usado para requisitar os dados.
     * Componente: Table.vue
     * @function
     * @returns {void}
     */
    updateSearch(mode, data) {
      switch (mode) {
        case "filters":
          this.search.where = data;
          this.search.page = 1;
          break;
        case "pagination":
          this.search.page = data.currentPage;
          this.search.pagesize = data.itemsPerPage;
          break;
      }

      this.updateData();
    },

    /**
     * Realiza a requisição e a atualização dos dados com base nos novos filtros.
     * Componente: Table.vue
     * @function
     * @async
     * @returns {void}
     */
    async updateData() {
      this.loading = true;
      const response = await TableManagement.searchData(
        this.service,
        this.search
      );

      // Atualiza as linhas da tabela
      this.rows = response.result;

      // Atualiza as informações da paginação
      this.pagination = {
        currentPage: response.current_page,
        lastPage: response.lastpage,
        itemsPerPage: response.per_page,
        count: response.count,
      };

      this.loading = false;
    },

    async downloadExcel() {
      const data = await TableManagement.searchData(
        this.service,
        this.search,
        true
      );

      await TableManagement.downloadExcel("Licenças", "Dados", data.result);
    },

    hideCreateLicenseModal() {
      this.createLicenseModal.hide();
    },

    openNewTabPDF(blobURL) {
      window.open(blobURL, "_blank");
    },

    openPDFModal() {
      this.pdfModal.object = new Modal(
        document.getElementById(this.pdfModal.id)
      );
      this.pdfModal.object.show();
    },

    /**
     * Abre o modal para criar ou atualizar uma licença.
     *
     * @param {string} operation - Operação a ser realizada (Create ou Update).
     * @param {object} [license=null] - Objeto contendo informações da licença a ser atualizada. Opcional, utilizado apenas na operação de atualização.
     */
    openLicenseModal(operation, license = null) {
      license = license === null ? license : license.row.id;

      // Verifica o modo do modal com base na operação e reinicia o formulário
      this.$refs.CreateLicenseModalRef.verifyOperation(operation, license);
      this.$refs.CreateLicenseModalRef.resetDirtyForm();

      // Exibe o modal de criação de licença
      this.createLicenseModal.show();
    },

    /**
     * Busca e exibe o documento relacionado a uma licença com base no ID da licença.
     *
     * @param {string} licenseID - ID da licença para buscar o documento.
     * @throws {Error} Se houver um erro ao carregar o documento.
     */
    async getDocumentByLicenseId(licenseID) {
      try {
        const response = await this.service.getDocumentByLicenseID(licenseID);

        // Cria um Blob com os dados do documento e define o tipo do arquivo
        const blob = new Blob([response.data], { type: response.type });

        // Cria um URL para o Blob, permitindo abrir o arquivo em uma nova aba
        const blobURL = URL.createObjectURL(blob);

        // Abre o documento em um modal
        this.pdfModal.blobURL = blobURL;
        this.openPDFModal();
      } catch (error) {
        throw new Error("Erro ao carregar documento");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";

/* Personalizando padrão dos botões de ação */

.action {
  margin: 0 0.5em;
}

/* Personalização do conteúdo exibido no modal do PDF */

div#contentPDF {
  display: flex;
  flex-direction: column;

  a {
    margin-bottom: 1em;
    text-align: center;
    color: $azul-principal;
  }

  object {
    width: 100%;
    height: 600px;
  }
}

/* Espaçamento dos botões de ação */

.buttons {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
}

@media (max-width: $mobile-bp) {
  div#contentPDF {
    object {
      height: 70vh;
    }
  }
}
</style>
